// API Configuration
// Use production URL by default, can be overridden with REACT_APP_API_BASE_URL environment variable
const isDevelopment = process.env.NODE_ENV === 'development';
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 
    (isDevelopment ? 'http://localhost:3000/backend/api' : 'https://metasadventistschoolranchi.com/backend/api'),
  TIMEOUT: 30000, // 30 seconds
};

// API Endpoints
export const API_ENDPOINTS = {
  CLASSES: '/classes',
  SECTIONS: (classCode: string) => `/classes/${classCode}/sections`,
  STUDENTS_BY_CLASS: (classCode: string) => `/students/class/${classCode}`,
  SEARCH_STUDENTS: (classCode: string, query: string) => `/students/search/${classCode}/${encodeURIComponent(query)}`,
  STUDENT_BY_CODE: (studentCode: string) => `/students/code/${studentCode}`,
  STUDENT_BY_ID: (studentId: string) => `/students/id/${encodeURIComponent(studentId)}`,
  ACADEMIC_YEARS: '/academic-years',
  TUITION_STATEMENT: (studentCode: string) => `/students/${studentCode}/tuition-statement`,
  TRANSPORTATION_STATEMENT: (studentCode: string) => `/students/${studentCode}/transportation-statement`,
};
